Vendd.Scripts.load(function () {
    var $form = $('.x-request-info-form'), form, formData, files = [], sentConsents = false, submitted = false;

    if ($form.length < 1) return;

    form = $form.get(0);

    formData = {
        gender: $("input[name='gender']:checked", $form).val() ? $("input[name='gender']:checked", $form).val() : "",
        firstName: $("input[name='firstName']", $form).val() ? $("input[name='firstName']", $form).val() : "",
        lastName: $("input[name='lastName']", $form).val() ? $("input[name='lastName']", $form).val() : "",
        email: $("input[name='email']", $form).val() ? $("input[name='email']", $form).val() : "",
        phone: $("input[name='phone']", $form).val() ? $("input[name='phone']", $form).val() : ""
    };
 
    // reCAPTCHA
    var reCaptchaCode;
    var captchaId = "requestInfoFormCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
            //accessibility fix
            $('#g-recaptcha-response').attr('aria-label', 'recaptcha response');
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled) {
            grecaptcha.reset(captchaWidgetId);
            $captchaContainer.find('.recaptcha-required').removeClass('error');
        }
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', $form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Custom Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            sentConsents = true;
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    };

    form.submit = function () {
        form.loading(true);

        $('input:not([type="checkbox"],[type="radio"],[type="file"]), textarea:not([name="g-recaptcha-response"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        var data = {
            Gender: formData.gender,
            FirstName: formData.firstName,
            LastName: formData.lastName,
            Email: formData.email,
            Phone: formData.phone,
            ModelName: $form.attr('data-model-name') || '',
            ModelId: $form.attr('data-model-id') || '',
            ItemId: parseInt($form.attr('data-item-id') || 0),
            RecaptchaToken: reCaptchaCode
        };

        submitted = true;

        $.ajax({
            type: 'POST',
            url: '/vendd/webapi/cstmJetour/RequestInfoByModel',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function (response) {
                form.loading(false);

                if (response && response.success) {
                    $('.js-error', $form).hide();
                    $('.js-generic-error', $form).hide();
                    $('.js-content', $form).hide();
                    $('.js-success', $form).show();

                    form.reset();
                } else {
                    if (response && response.message) {
                        $('.js-error', $form).text(response.message).show();
                    } else {
                        $('.js-generic-error', $form).show();
                    }

                    form.resetRecaptcha();
                }

                submitted = false;
            },
            error: function (xhr) {
                form.loading(false);

                if (xhr.responseJSON && xhr.responseJSON.message) {
                    $('.js-error', $form).text(xhr.responseJSON.message).show();
                } else {
                    $('.js-generic-error', $form).show();
                }

                form.resetRecaptcha();

                submitted = false;
            }
        });
    };

    form.reset = function () {
        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="phone"]', $form).val("");

        $('input[name="requestInfoTerms"]', $form).prop('checked', false);

        form.resetRecaptcha();

        cf.reset();
    };

    form.initialize = function () {
        //reset form data
        $form.attr('data-item-id', '');
        $form.attr('data-model-id', '');
        $form.attr('data-model-name', '');

        //reset form fields
        form.reset();

        //reset messages
        $('.js-error', $form).hide();
        $('.js-generic-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show(); 
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cf.validate();
        var val2 = form.validateRecaptcha();

        if (val1 && val2) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }
        }

        initialValidation = true;
    });

    $form.on('blur', 'input[name]:not([type="checkbox"],[type="radio"],[type="file"]), textarea[name]', function (e) {
        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "email") {
                cf.validateField("email");
            }

            if ($(this).attr('name') === "phone") {
                cf.validateField("phone");
            }

            if ($(this).attr('name') === "mobilephone") {
                cf.validateField("mobilephone");
            }
        }

        form.setField($(this));
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"],[type="radio"],[type="file"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    $form.on('change', 'select[name], input[name][type="radio"]', function (e) {
        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        cf.validate(fieldName);
    };

    //init validation options
    var validationOptions = {}, initialValidation = false;

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        validationOptions[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('div.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        validationOptions.email = validationOptions.email || {};
        validationOptions.email = { ...validationOptions.email, ...{ isEmail: 'email-invalid' } };
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        validationOptions.phone = validationOptions.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            validationOptions.phone = { ...validationOptions.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'mobile' } } } };
        } else {
            validationOptions.phone = { ...validationOptions.phone, ...{ isPhoneNumber: 'phone-invalid' } };
        }
    }

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    var $consents = $('.form-row.consent input[type="checkbox"]', $form);

    $consents.on('click', function () {
        var fieldName = $(this).attr('name');

        cf.validate(fieldName);
    });

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, function () {
        if (sentConsents) {
            sentConsents = false;
            form.submit();     
        }
    });
});